
import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PayModalUI from './PayModalUI'

class PayModalSF extends Component {
	constructor(props) {
		super(props)
		this.state = {
			successMsg: null,
			errorList: null,
			// form events
			submitted: false,
			otpRequested: false,
			// form field
			otp: '',
			otpError: null,
		}
	}

	render() {

		return (
			<PayModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				// form fields
				otp={this.state.otp}
				onOtpChange={(event) => { this.setState({ otp: event.target.value }) }}
				otpError={this.state.otpError}
				setOtpError={(error) => { this.setState({ otpError: error }) }}
				// modes
				payMode={this.props.payMode}
				submitted={this.state.submitted}
				otpRequested={this.state.otpRequested}
				// event handlers
				onSubmit={this.handleOnSubmit}
				onPayCancel={this.props.onPayCancel}
				selectedBill={this.props.selectedBill}
			/>
		)
	}

	componentDidMount() {
		Modal.setAppElement('body')
	}

	componentDidUpdate(prevProps) {
		if (this.props.selectedBill == null)
			return
		if (prevProps.selectedBillId === this.props.selectedBillId)
			return
	}

	
	handleOnSubmit = (event) => {
		this.state.otpRequested ? this.onSubmit(event) : this.onGetOtpClick(event)
	}
	onGetOtpClick = (event) => {
		event.preventDefault()
		if (this.state.otpRequested) return

		const { context, loan, selectedBillId } = this.props

		this.setState({
			successMsg: null,
			errorList: [],
			otpRequested: true
		})

		RestApiUtils.post(
			context,
			`/api/su/accounts/${loan.accountId}/loans/${loan.loanId}/vendorBills/${selectedBillId}/bankPayments/otp`,
			this.onGetOtpCallback
		)
	}
	onGetOtpCallback = (response) => {
		let errorList = []
		if (response.errorList) {
			response.errorList.forEach(error => {
				errorList.push(error.message)
			})
		}

		this.setState({
			successMsg: response.success,
			errorList: errorList
		})

		if (response.errorList && response.errorList.length === 0) {
			setTimeout(() => {
				this.setState({
					otpSuccessMsg: null
				})
			}, 1000)
		}
	}

	onSubmit = (event) => {
		event.preventDefault()
		if (this.state.submitted) return

		const { context, loan, selectedBillId } = this.props

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true
		})

		RestApiUtils.post(
			context,
			`/api/su/accounts/${loan.accountId}/loans/${loan.loanId}/vendorBills/${selectedBillId}/bankPayments`,
			this.onSubmitCallback,
			{ "otp" : this.state.otp}
		)
	}

	onSubmitCallback = (response) => {
		let errorList = []
		if (response.errorList) {
			response.errorList.forEach(error => {
				errorList.push(error.message)
			})
		}

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false,
			otpRequested: false
		})

		if (response.errorList && response.errorList.length === 0) {
			setTimeout(() => {
				this.setState({
					successMsg: null
				})
				this.props.onRefreshClick()
				this.props.onPayCancel()
			}, 1000)
		}
	}


	setErrorList = (errorList) => {
		this.setState({ errorList: errorList })
	}
}

export default withRouter(PayModalSF)
